'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationItemStorePropType = exports.NavigationItemPropType = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationItemPropType = exports.NavigationItemPropType = _propTypes2.default.shape({
  id: _propTypes2.default.number,
  page_id: _propTypes2.default.number,
  navigation_section_id: _propTypes2.default.number,
  expanded: _propTypes2.default.bool,
  editing: _propTypes2.default.bool
});

var NavigationItemStorePropType = exports.NavigationItemStorePropType = _propTypes2.default.shape({
  navigationItems: _reactImmutableProptypes2.default.mapOf(NavigationItemPropType.isRequired, _propTypes2.default.number.isRequired).isRequired
});


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/propTypes.js
// module id = 25
// module chunks = 0